module.exports = __webpack_public_path__ + "img/ibtikar_logo.3fdb82c8.png";